import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	columnHeaderExpandButton: {
		id: 'native-issue-table.column-header-expand-button',
		defaultMessage: 'Show all issues - expanded',
		description: 'Label for header column of expand icon',
	},
	columnHeaderCollapseButton: {
		id: 'native-issue-table.column-header-collapse-button',
		defaultMessage: 'Show all issues - collapsed',
		description: 'Label for header column of collapse icon',
	},
});
